(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('cadastroSearchBox', CadastroSearchBoxDirective);

  function CadastroSearchBoxDirective() {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        submit: '&',
        clear: '&',
        showClear: '<'
      },
      link(scope) {
        scope.showSearch = true;
      },
      templateUrl: 'views/cadastros/cadastro-search-box.html'
    };
  }
}());
